import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function PunjabIncarceration() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  });
  return (
    <div>
      <h2 className="text-h-black">Stories of Incarceration</h2>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="text-p-orange">Invisibilising Identity</p>
          <p>
            Sixty-five-year-old Farooq Amjad, a security in-charge at a Jhelum
            area rubbish disposal factory, was accused of deliberately burning
            the Quran by a driver who also worked at the facility.
          </p>
          <div
            className="my-5"
            data-aos="fade-left"
            data-aos-duration="900"
            data-aos-delay="300"
          >
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              // className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/FAROOQ.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
        <div className="voice-sect-style">
          <p className="text-p-orange">Dispossessed in Detention</p>
          <p>
            Hassan, 60, spent 14 months in Layyah jail, on allegations that he
            had committed blasphemy.
          </p>
          <div
            className="my-5"
            data-aos="fade-right"
            data-aos-duration="900"
            data-aos-delay="300"
          >
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/HASAN.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
        <div className="voice-sect-style">
          <p className="text-p-orange">
            Rehabilitation comes to the majority faith
          </p>
          <p>
            Sohail Yafat, went to prison for 10 years with a murder conviction,
            a crime he maintains he did not commit.
          </p>
          <div
            className="my-5"
            data-aos="fade-left"
            data-aos-duration="900"
            data-aos-delay="300"
          >
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/SOHAIL.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PunjabIncarceration;
